import { createSelector } from 'reselect';
import { getFilterValues } from './getFilterValues';
import { DEFAULT_CHAT_FILTERS } from '../constants/defaultChatFilters';
import { HIDE_FILTERED, HIDE_TRASH } from '../constants/FilterKeys';
const ignoreToggles = record => record.delete(HIDE_FILTERED).delete(HIDE_TRASH);
export const hasFiltersSet = createSelector([getFilterValues], filterValues => {
  return !ignoreToggles(filterValues).equals(ignoreToggles(DEFAULT_CHAT_FILTERS));
});